<template>
    <div id="trialBalanceReport">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Trial Balance Report</div>
                    <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content trial-balance-report">
                        <data-table-filter-config :moduleName="'trialBalanceReport'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'trialBalanceReport'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="trialBalance"
                                    mode="remote"
                                    title="Trial Balance"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'period_amount'">
                                                <a href="javascript:void(0)" title="View General Ledger" class="color-blue" v-on:click.prevent="viewGeneralLedger(props.row.gl_year,props.row.gl_month,props.row.gl_code)">{{props.row.period_amount}}</a>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../../mixins/commonMixins';
// import {contractMixins} from '../../../mixins/contractMixins';
// import VMdDateRangePicker from "v-md-date-range-picker";
// import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
// import moment from 'moment';
import {dataTableMixins} from '../../../mixins/dataTableMixins';
// Vue.use(VMdDateRangePicker);
export default {
    name: "TrialBalanceReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Trial Balance Report | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        permissions:[],
        loading:false,
        batchProcess:0,
        batchNum:"",
        cantAccessPage:"",
        userColumns:[],
        columns:[
            {
                label:'GL Account Code',
                field:'gl_code',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
            },
            {
                label:'Account Description',
                field:'gl_desc',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
            },
            {
                label:'Beginning Balance',
                field:'opening_balance',
                fpFieldType:"integer",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Period Amount',
                field:'period_amount',
                fpFieldType:"integer",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Debit Amount',
                field:'debit',
                fpFieldType:"integer",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Credit Amount',
                field:'credit',
                fpFieldType:"integer",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Ending Balance',
                field:'closing_balance',
                fpFieldType:"integer",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Account Type',
                field:'account_type',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
            },
            {
                label:'Facility',
                field:'location',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
            },
            {
                label:'Natural Acct',
                field:'natural_account',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Product Line',
                field:'product_line',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Functional Area',
                field:'functional_area',
                fpFieldType:"text",
                filterable:true,
                hidden:false,
                type:'number',
            },
            {
                label:'Year',
                field:'year',
                fpFieldType:"year",
                filterable:false,
                hidden:true,
                sortable:false,
                fpMandatory:true
            },
            {
                label:'Beginning Period',
                field:'beginning_period',
                fpFieldType:"period",
                filterable:false,
                hidden:true,
                sortable:false,
                fpMandatory:true
            },
            {
                label:'Ending Period',
                field:'ending_period',
                fpFieldType:"period",
                filterable:false,
                hidden:true,
                sortable:false,
                fpMandatory:true
            },
            {
                label:'Activity',
                field:'activity',
                fpFieldType:"option",
                filterable:true,
                hidden:false,
                sortable:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Select Activity", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Yes (Y)', 'No (N)'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows:[],
        totalRecords:0
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'trial_balance_report') {
                    self.cantAccessPage = true;
                }
            });
        }
    },
    created: function() {
        this.serverParams.sort = {field:"gl_code",type:"asc"};
        this.serverParams.stopRequest = true;
    },
    mounted: function () {

        this.getPermissions();
    },
    methods:{
        cancelAll: function (cancelAll) {
              this.$refs.trialBalance.unselectAllInternal();
            },

        loadList: function() {

            var self = this;
            var selectedYear = "";
            var selectedPeriod = "";
            var endingPeriod = "";
            if (self.serverParams.columnFilters.length > 0) {
                for(var i = 0;i < self.serverParams.columnFilters.length;i++) {
                    if (self.serverParams.columnFilters[i] != undefined) {
                        if (self.serverParams.columnFilters[i] != null) {
                            if (self.serverParams.columnFilters[i].columnId != null) {
                                if (self.serverParams.columnFilters[i].columnId.field != null) {
                                    if (self.serverParams.columnFilters[i].columnId.fpFieldType == "year") {
                                        selectedYear = self.serverParams.columnFilters[i].filterValue;
                                    }
                                    if (self.serverParams.columnFilters[i].columnId.field == "beginning_period" && self.serverParams.columnFilters[i].columnId.fpFieldType == "period") {
                                        selectedPeriod = self.serverParams.columnFilters[i].filterValue;
                                    }
                                    if (self.serverParams.columnFilters[i].columnId.field == "ending_period" && self.serverParams.columnFilters[i].columnId.fpFieldType == "period") {
                                        endingPeriod = self.serverParams.columnFilters[i].filterValue;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (selectedYear.trim() == "" || selectedPeriod.trim() == "" || endingPeriod.trim() == "") {
                return;
            }

            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action:self.action
            };

            self.firstLoad = 1;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/accounting/reports/trial-balance",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if (self.action =='export' ||  self.action == "export_queue"){


                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {

                                 if ( self.action == "export" ) {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                            self.loadList();
                            return;
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'trial-balance-report');
                }
            });
        },
        // exportTrialBalance() {
        //     var self = this;
        //     this.action = "export";
        //     this.loadList();
        // },
        viewGeneralLedger(glYear,glMonth,glCode) {
            var self = this;
            var link = '/report/general-ledger?from=trialbalance';
            var params = '&year='+glYear+'&month='+glMonth+'&code='+glCode;
            link += '&data=';
            link += btoa(params);

            let routeData = self.$router.resolve(link);
            window.open(routeData.href, '_blank');
        }
    }
}
</script>
<style scoped>
.tax-title{
    font-family: 'SanFranciscoDisplayBold' !important;
}
.amount-right-align{
    text-align: right !important;
}
.account-type-title{
    background-color: #9badc1;
    color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/accounting/reports/TrialBalanceReport.vue